<!-- SimpleFlexTableTitledRow.vue -->
<script setup lang="ts">
    import { computed, inject } from 'vue';

    const injectedRowClass = inject('rowClass');
    const injectedColumnClasses= inject<string[]|undefined>('columnClasses');

    const rowClass = computed(() => injectedRowClass ?? "simple-row simple-row-zebra");
    const firstColClass = computed(() => { 
        if (injectedColumnClasses && injectedColumnClasses.length >= 1)
            return injectedColumnClasses[0];
        return "simple-cell";

    });
    const secondColClass = computed(() => { 
        if (injectedColumnClasses && injectedColumnClasses.length >= 2)
            return injectedColumnClasses[1];
        return "simple-cell";

    });
</script>

<template>
    <div :class="rowClass">
        <div :class="firstColClass">
            <slot name="Title"></slot>
        </div>
        <div :class="secondColClass">
            <slot></slot>
        </div>
    </div>
</template>